'use es6';

import logo from 'bender-url!../../img/hubspot-tools-logo.png';
import text from 'I18n/utils/unescapedText';
import { useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const Logo = ({
  onClick
}) => {
  const classes = Boolean(onClick) ? "clickable" : "";
  const theme = useTheme();
  return /*#__PURE__*/_jsx("div", {
    className: "logo",
    children: /*#__PURE__*/_jsx("img", {
      width: "151px",
      alt: text('altText.logo'),
      className: `${classes}`,
      src: theme.logo && theme.logo.url || logo,
      onClick: onClick
    })
  });
};
export default Logo;